import getItemAvailability from './getItemAvailability';
import getItems from './getItems';

// Returns a map of choice ID -> true for each choice that is currently unavailable.
// We look up the full Item from allItems to get mimCategoryId — the menu submenu node ID
// used by getItemAvailability to check category-level daypart availability. Choices not
// registered as top-level items (e.g. nested choices) fall back to their own daypart
// fields with no category check.
export const getUnavailableChoices = (
  choices: Choice[],
  state: EntireFrontendState,
): SDict<boolean> => {
  const allItems = getItems(state);
  return choices.reduce<SDict<boolean>>((acc, choice) => {
    const fullItem = allItems?.[choice.id] as Item | undefined;
    // getItemAvailability returns a tuple instead of an object which is why we have to destructure like this: [isAvailable]
    const [isAvailable] = getItemAvailability(
      fullItem ?? (choice as unknown as Item),
      fullItem?.mimCategoryId,
    )(state);
    acc[choice.id] = !isAvailable;
    return acc;
  }, {});
};
